<body class="vision-light-theme" (click)="refreshActivityTimer()">
  <app-layout></app-layout>
  <div class="bottom-panel">
    @if ((downloads$ | async); as downloads) {
      @if (downloads.length > 0) {
        <operation-feedback [items]="downloads" (cancel)="onCancelDownload($event)"
        (close)="onCancelDownloads()" (refresh)="onRetryDownload($event)"></operation-feedback>
      }
    }
    <fw-snackbar-container></fw-snackbar-container>
  </div>

  <!-- Agent Chatbox Integration -->
  @if (configService.isAssistantChatEnabled()) {
    <agent-chatbox></agent-chatbox>
  }
</body>
